<app-navbar [title]="'Rezerwacje'">
	<button class="btn btn-primary me-2" (click)="showRefresh = !showRefresh">
		<i class="fas fa-sync-alt"></i> Odśwież rezerwację
	</button>
</app-navbar>

<app-reservation-refresh *ngIf="showRefresh"></app-reservation-refresh>
